import InsideDrawer, { IDrawerSettings } from '@src/shared/components/InsideDrawer';
import { DrawerType, useInsideDrawerActions } from '@src/shared/context/inside-drawer';
import React, { useState } from 'react';
import styles from './UserpanelDrawer.module.scss';
import UserLogo from '@src/shared/components/UserLogo';
import { IconClose } from '@justeattakeaway/pie-icons-react';
import UserInformationContent from './components/UserInformationContent';
import LanguageSelectionContent from './components/LanguageSelectionContent';
import useOnboardingTracking from '@src/pages/DeliveryDashboard/components/DashboardOnboarding/tracking/use-onboarding-tracking';

const drawerSettings: IDrawerSettings = {
  anchor: 'right',
  fullSize: true,
  customClose: true,
  drawerVariant: 'temporary',
};

const UserPanelDrawer = () => {
  const { setDrawerFlush } = useInsideDrawerActions();
  const [showLanguageContent, setShowLanguageContent] = useState<Boolean>(false);
  const { trackReviewTutorial } = useOnboardingTracking();
  return (
    <InsideDrawer
      onClose={setDrawerFlush}
      type={DrawerType.USER_PANEL}
      settings={drawerSettings}
      titleI18nKey=""
    >
      <div className={styles.UserPanelDrawer} style={{ height: window.innerHeight - 57 }}>
        <div className={styles.UserPanelDrawerHeader}>
          <IconClose size="m" onClick={() => setDrawerFlush()} />
          <UserLogo />
        </div>
        {(!showLanguageContent && (
          <UserInformationContent
            onTutorialReview={() => {
              trackReviewTutorial();
              setDrawerFlush();
            }}
            onLanguageMenu={() => setShowLanguageContent(true)}
          />
        )) || <LanguageSelectionContent onClose={() => setShowLanguageContent(false)} />}
      </div>
    </InsideDrawer>
  );
};

export default UserPanelDrawer;
